// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"multi-select_dropdownMenu__hWLLa","multiSelect":"multi-select_multiSelect__QGco5"};